import React, { useEffect, useRef, useState } from 'react';
import './splash.css';
import { useNavigate } from 'react-router-dom';
import key from '../assets/key.png';
import halloweenJam from '../audios/halloween-jam-spooky-kids-music-theme-brukowskij-2-2-00-13.mp3';

const Splash = () => {
    const navigate = useNavigate();
    const canvasRef = useRef(null);
    const audioRef = useRef(null);
    const [percent, setPercent] = useState(0);
    const [audioUnlocked, setAudioUnlocked] = useState(false);
    useEffect(() => {
        const audio = new Audio(halloweenJam);
        audio.loop = true;
        audio.preload = 'auto';
        audio.volume = 0.3;
        audioRef.current = audio;

        
        audio.play()
            .then(() => {
                setAudioUnlocked(true);
            })
            .catch(() => {
              
            });

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);
    useEffect(() => {
        if (audioUnlocked) return;

        const unlock = () => {
            const audio = audioRef.current;
            if (!audio) return;

            audio.play()
                .then(() => {
                    setAudioUnlocked(true);
                    window.removeEventListener('touchstart', unlock);
                    window.removeEventListener('pointerdown', unlock);
                })
                .catch(() => {});
        };

        window.addEventListener('touchstart',  unlock, { once: true });
        window.addEventListener('pointerdown', unlock, { once: true });

        return () => {
            window.removeEventListener('touchstart',  unlock);
            window.removeEventListener('pointerdown', unlock);
        };
    }, [audioUnlocked]);

    useEffect(() => {
        const timer = setTimeout(() => navigate('/start'), 6500);
        return () => clearTimeout(timer);
    }, [navigate]);

    useEffect(() => {
        let start = null;
        const duration = 5000;
        const delay    = 1000;

        const step = (timestamp) => {
            if (!start) start = timestamp;

            const elapsed  = Math.max(0, timestamp - start - delay);
            const progress = Math.min(100, Math.floor((elapsed / duration) * 100));

            setPercent(progress);
            if (progress < 100) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        const resize = () => {
            canvas.width  = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        resize();
        window.addEventListener('resize', resize);

        const particles = Array.from({ length: 60 }, () => ({
            x:     Math.random() * canvas.width,
            y:     Math.random() * canvas.height,
            vx:    (Math.random() - 0.5) * 0.4,
            vy:    (Math.random() - 0.5) * 0.4,
            size:  Math.random() * 1.5 + 0.5,
            alpha: Math.random() * 0.4 + 0.1,
        }));

        let animId;

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            particles.forEach((p) => {
                p.x += p.vx;
                p.y += p.vy;

                if (p.x < 0)             p.x = canvas.width;
                if (p.x > canvas.width)  p.x = 0;
                if (p.y < 0)             p.y = canvas.height;
                if (p.y > canvas.height) p.y = 0;

                ctx.beginPath();
                ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(212,175,55,${p.alpha})`;
                ctx.fill();
            });

            animId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            cancelAnimationFrame(animId);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return (
        <section className="splash1">

            <canvas ref={canvasRef} className="splashcanvas" />

            <div className="hudgrid" />
            <div className="darkoverlay" />

            <div className="corner corner1" />
            <div className="corner corner2" />
            <div className="corner corner3" />
            <div className="corner corner4" />

            <div className="hotelintro">

                <h2 className="welcometext">WELCOME TO</h2>

                <div className="titlewrapper">
                    <img src={key} alt="" className="floatingkey" />
                    <h1 className="hoteltitle" data-text="MYSTERY HOTEL">
                        MYSTERY HOTEL
                    </h1>
                </div>

                <p className="hotelquote">
                    Check In...
                    <br />
                    If You Dare.
                </p>

                <div className="statusline">
                    <div className="statusdot" />
                    <span className="statustext">
                        INITIALIZING ROOM ASSIGNMENT
                    </span>
                </div>

                <div className="loadingline">
                    <div className="loadingfill" />
                </div>

                <span className="loadpercent">{percent}%</span>

               
                {!audioUnlocked && (
                    <span className="audio">
                    </span>
                )}

            </div>

        </section>
    );
};

export default Splash;